
function SdAvatarsController() {
    var ctrl = this;

   

   }

seedWebApp.component('sdAvatars', {
    controller: SdAvatarsController,
    controllerAs: 'ctrl',
    bindings: {
        users: '<',
        fieldName: '<'
    },
    templateUrl: './SPA/components/sd-avatars.html'
});